import { isEqual, get, cloneDeep } from 'lodash'

import { ResponseCode } from '../constants/constants'
import httpClient from './httpClient'

const mentorApplicationReviewerDataProvider = {
  getList: (params) => {
    const getMentorApplicationReviewersUrl = `/admin/mentor/get_application_reviewers`;

    return httpClient(getMentorApplicationReviewersUrl, {
      method: 'GET',
    }).then(({ json }) => {
      const reviewers = get(json, 'reply.reviewers', []).map(reviewer => {
        return {
          ...reviewer,
          name: reviewer.display_name || reviewer.email, // map field for displaying choices
        }
      })
      return {
        data: reviewers,
        total: reviewers.length
      }
    })
  },

  getOne: (params) => {
    
  },

  getMany: (params) => {
    const getMentorApplicationReviewersUrl = `/admin/mentor/get_application_reviewers`;

    return httpClient(getMentorApplicationReviewersUrl, {
      method: 'GET',
    }).then(({ json }) => {
      const reviewers = get(json, 'reply.reviewers', []).map(reviewer => {
        return {
          ...reviewer,
          name: reviewer.display_name || reviewer.email, // map field for displaying choices
        }
      })
      return {
        data: reviewers,
      }
    })
  },

  update: async (params) => {
    const { id, data, previousData } = params

    if (!isEqual(get(data, 'review.review_result', ''), get(previousData, 'review.review_result', ''))) {
      await mentorApplicationReviewerDataProvider.setMentorApplicationReviewOverallResult({
        id,
        data: {
          review_result: data.review.review_result,
        }
      })
    }

    if (!isEqual(data.reviewer_1, previousData.reviewer_1) || !isEqual(data.reviewer_2, previousData.reviewer_2)) {
      await mentorApplicationReviewerDataProvider.updateMany({
        ids: [id],
        data: {
          reviewer_1: data.reviewer_1,
          reviewer_2: data.reviewer_2
        }
      })
    }

    if (!isEqual(data.my_review, previousData.my_review)) {
      await mentorApplicationReviewerDataProvider.setMentorApplicationReviewerResult({ id , data: data.my_review })
    }

    return Promise.resolve({ data })
  },

  updateMany: async (params) => {
    const { ids, data } = params

    const assignMentorApplicationReviewersUrl = `/admin/mentor/assign_application_reviewers`;

    let reviewersData = cloneDeep(data)
    if (!reviewersData.reviewer_1) delete reviewersData.reviewer_1
    if (!reviewersData.reviewer_2) delete reviewersData.reviewer_2

    return httpClient(assignMentorApplicationReviewersUrl, {
      method: 'POST',
      body: JSON.stringify({
        application_ids: ids,
        ...reviewersData,
      })
    }).then(({ json }) => {
      const result = get(json, 'result', null)
      if (result === ResponseCode.SUCCESS) {
        return {
          data: ids
        }
      } else {
        throw new Error(result)
      }
    })
  },

  setMentorApplicationReviewerResult: async ({ id, data}) => {
    const setMentorApplicationReviewerResultUrl = `/admin/mentor/set_application_reviewer_result`;

    return httpClient(setMentorApplicationReviewerResultUrl, {
      method: 'POST',
      body: JSON.stringify({
        application_id: id,
        review_result: data
      })
    })
  },

  setMentorApplicationReviewOverallResult: async ({ id, data }) => {
    const setMentorApplicationReviewOverallResultUrl = `/admin/mentor/set_application_review_overall_result`;

    return httpClient(setMentorApplicationReviewOverallResultUrl, {
      method: 'POST',
      body: JSON.stringify({
        application_id: id,
        review_result: data
      })
    })
  }
};

export default mentorApplicationReviewerDataProvider
